import React from 'react';
import TeamMember from './TeamMember';
import TeamSection from './TeamSection';
import Icon7 from "../img/39bdbd3d6dd984bb089adc962360313ddb8583124ff2d09951ea412232d84099.svg";
const nettlesTeam = [
  {
    name: "Ryan Norder",
    role: "Vice President of Operations - Operations",
    initials: "RN"
  },
  {
    name: "Donnie Moore",
    role: "Operations Manager - Operations",
    initials: "DM"
  },
  {
    name: "Brandon Price",
    role: "Superintendent - Operations",
    initials: "BP"
  },
  {
    name: "Kevin Soots",
    role: "Regional Sales Manager - Operations",
    initials: "KS"
  },
  {
    name: "Robyn Lieggi",
    role: "Drafter - Operations",
    initials: "RL"
  },
  {
    name: "Marcai Baker",
    role: "Project Account - Accounting",
    initials: "MB"
  }
];

const vendors = [
  {
    name: "Commander Contractor",
    role: "Vice President of Operations - Operations",
    initials: "CC"
  },
  {
    name: "Commander Contractor",
    role: "Vice President of Operations - Operations",
    initials: "CC"
  },
  {
    name: "Commander Contractor",
    role: "Vice President of Operations - Operations",
    initials: "CC"
  },
  {
    name: "Commander Contractor",
    role: "Vice President of Operations - Operations",
    initials: "CC"
  },
  {
    name: "Commander Contractor",
    role: "Vice President of Operations - Operations",
    initials: "CC"
  },
  {
    name: "Commander Contractor",
    role: "Vice President of Operations - Operations",
    initials: "CC"
  }
];

const designTeam = [
  {
    name: "Architecty person",
    role: "Vice President of Operations - Operations",
    initials: "AP"
  },
  {
    name: "Architecty person",
    role: "Vice President of Operations - Operations",
    initials: "AP"
  },
  {
    name: "Architecty person",
    role: "Vice President of Operations - Operations",
    initials: "AP"
  }
];

function ProjectTeam() {
  return (
    <section data-layername="projectTeam" className="flex flex-col px-9 py-4 mt-7 rounded-xl bg-stone-50 max-md:px-5 max-md:mr-2.5 max-md:max-w-full">
      <header className="flex flex-wrap gap-4 items-center w-full text-xl font-semibold text-zinc-800 max-md:max-w-full">
        <h1 data-layername="projectTeam" className="grow shrink self-stretch my-auto w-[1434px] max-md:max-w-full">
          Project Team
        </h1>
        <img loading="lazy" src={Icon7} alt="" className="object-contain shrink-0 self-stretch my-auto w-3 aspect-[2]" />
      </header>
      <main className="flex flex-wrap gap-10 items-start px-12 py-7 mt-4 w-full bg-white rounded-xl max-md:px-5 max-md:max-w-full">
        <TeamSection title="Nettles Project Team" members={nettlesTeam} />
        <TeamSection title="Vendors" members={vendors} />
        <TeamSection title="Design Team" members={designTeam} />
      </main>
    </section>
  );
}

export default ProjectTeam;
